module.exports = __webpack_public_path__ + "static/media/brycen3.90b76a99.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brycen3.gif
// module id = 148
// module chunks = 0